<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormPersonal" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="row">
						<div class="col-12 col-sm-12 col-md-3 col-lg-1 col-xl-1">Año</div>
						<div class="col-12 col-sm-12 col-md-3 col-lg-2 col-xl-2">
							<select v-model="Anio" @change="GetListPersonal()" class="form-control form-select">
								<option v-for="(item,index) in Fechas" :key="index" :value="item">{{item}}</option>
							</select>
						</div>
					</div>

					<div class="row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12">
							<table class="table">
								<thead>
									<tr>
										<th :class="Style">Nombre</th>
										<th :class="Style">Ene</th>
										<th :class="Style">Feb</th>
										<th :class="Style">Mar</th>
										<th :class="Style">Abr</th>
										<th :class="Style">May</th>
										<th :class="Style">Jun</th>
										<th :class="Style">Jul</th>
										<th :class="Style">Ago</th>
										<th :class="Style">Sep</th>
										<th :class="Style">Oct</th>
										<th :class="Style">Nov</th>
										<th :class="Style">Dic</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item,index) in ListaPersonal" :key="index" @click="AsignarPersonal(item)" :class="['cursor-pointer',(item.IdUsuario == ExistePersonal.IdVendedor)?'filaSeleccionada':'']">
										<td>
											<div class="d-flex px-2 py-1">
												<div>
													<template v-if="item.UrlImg!=''">
														<img :src="RutaFile+item.UrlImg" class="avatar avatar-sm me-3" alt="user1">
													</template>
													<template v-else>
														<img src="@/assets/style/image/noProfile.png" class="avatar avatar-sm me-3" alt="user1">
													</template>
												</div>
												<div class="d-flex flex-column justify-content-center">
												<h6 class="mb-0 text-sm">{{item.NombreCompleto}}</h6>
												<p class="text-xs text-secondary mb-0">{{item.perfil.Nombre}}</p>
												</div>
											</div>
										</td>
										<td class="align-middle text-center">
											<span class="text-secondary text-xs font-weight-bold">{{item.Ene}}</span>
										</td>
										<td class="align-middle text-center">
											<span class="text-secondary text-xs font-weight-bold">{{item.Feb}}</span>
										</td>
										<td class="align-middle text-center">
											<span class="text-secondary text-xs font-weight-bold">{{item.Mar}}</span>
										</td>
										<td class="align-middle text-center">
											<span class="text-secondary text-xs font-weight-bold">{{item.Abr}}</span>
										</td>
										<td class="align-middle text-center">
											<span class="text-secondary text-xs font-weight-bold">{{item.May}}</span>
										</td>
										<td class="align-middle text-center">
											<span class="text-secondary text-xs font-weight-bold">{{item.Jun}}</span>
										</td>
										<td class="align-middle text-center">
											<span class="text-secondary text-xs font-weight-bold">{{item.Jul}}</span>
										</td>
										<td class="align-middle text-center">
											<span class="text-secondary text-xs font-weight-bold">{{item.Ago}}</span>
										</td>
										<td class="align-middle text-center">
											<span class="text-secondary text-xs font-weight-bold">{{item.Sep}}</span>
										</td>
										<td class="align-middle text-center">
											<span class="text-secondary text-xs font-weight-bold">{{item.Oct}}</span>
										</td>
										<td class="align-middle text-center">
											<span class="text-secondary text-xs font-weight-bold">{{item.Nov}}</span>
										</td>
										<td class="align-middle text-center">
											<span class="text-secondary text-xs font-weight-bold">{{item.Dic}}</span>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>
import moment from 'moment';
import Template from '../../../template/Template.vue';

export default {
    name: 'FormPersonalAsignacion',
    props: ['poBtnSave'],
    components:{
        Template
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
			objAsignado: {},
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			ListaPersonal: [],
			Style: 'text-uppercase text-green-black text-xxs font-weight-bolder opacity-7',
			Fechas: [],
			Anio: moment(new Date()).format('YYYY'),
			ExistePersonal:{
				IdVendedor: 0,
				IdCliente: 0,
			},
			segurity:{},
			RutaFile: '',
        }
    },
    methods :
    {
       	Guardar(Id)
        {
			if(!this.segurity.Save){
				this.$toast.warning('No se pudo procesar. No cuenta con los permisos para realizar la acción');
				return false;
			}

			let Texto = 'asignar';
			if(this.ExistePersonal.IdVendedor>0){
				Texto = 'reasignar';
			}
			
			this.$swal({
				title: '<h2 style="font-size:25px; font-weight: 700;">¿Desea '+Texto+' al ejecutivo de ventas?</h2>', 
				text: '',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Continuar',
				cancelButtonText: 'Cancelar',
				showCloseButton: true,
				showLoaderOnConfirm: true,
				confirmButtonColor: '#0096ED',
				cancelButtonColor: '#b92e27',
			}).then((result) =>
            {
                if(result.value)
                {
					this.errorvalidacion = [];
					this.poBtnSave.Toast = 0; 
					this.poBtnSave.DisableBtn = true;

					this.ExistePersonal.IdVendedor = Id;

					this.$http.post('reAsignarEjecutivo',
						this.ExistePersonal
					).then((res)=>{                 
						this.EjecutaConExito(res);
					}).catch(err=>{   
						this.EjecutaConError(err);
					});
				} 
            });			
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_seccionCliente');
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "clientes/"+this.objCliente.IdCliente
            ).then((res) => {
                this.objCliente = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objCliente.Fecha.replace(/-/g,'\/');
                this.objCliente.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.errorvalidacion = [];
			this.ListaEventos = [];
        },
		SetearFechas()
		{
			this.Fechas = [];
			let anioActual = moment(new Date()).format('YYYY');
			let unAnio = moment(new Date()).add(1,'year').format('YYYY');
			
			this.Fechas.push(anioActual);
			this.Fechas.push(unAnio);
		},
		GetListPersonal()
		{
			this.ConfigLoad.ShowLoader = true;
			this.$http.get('usersVentas', {
				params:{
					TipoUsuario: 'US',
					Estatus: 'Activo',
					GetMeses: 'SI',
					Anio: this.Anio,
				}
			}).then( (res) => {
				this.ListaPersonal = res.data.data;
				this.RutaFile = res.data.RutaFoto;
				this.segurity = res.data.segurity
			}).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
		},
		AsignarPersonal(item)
		{
			let Vendedor = this.ExistePersonal.IdVendedor;
			let Cliente = this.ExistePersonal.IdCliente;
			if(Vendedor>0){
				if(Vendedor == item.IdUsuario){
					this.$toast.info('El Usuario ya ha sido asignado');
				}
				else{
					this.Guardar(item.IdUsuario);
				}
			}
			else if(Cliente>0)
			{
				this.Guardar(item.IdUsuario);
			}
			else
			{
				this.bus.$emit('SetearPersonal',item);
				this.bus.$emit('CloseModal_'+this.Emit);
			}
		},
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(item)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
			this.SetearFechas();
			
                
            if (Object.keys(item).length !== 0) 
            {
				this.ExistePersonal.IdCliente = item.IdCliente;

				if(item.IdVendedor>0){
					this.ExistePersonal.IdVendedor = item.IdVendedor;
				}
            }

			this.GetListPersonal();
        });
    }
}
</script>
